<template>
    <Modal v-model:visible="visible">
        <template v-slot:header>
            <div>
                <h2 class="text-lg font-bold">Carica da Excel</h2>
            </div>
        </template>
        <template v-slot:main>
            <div class="grow-0 min-h-10 gap-2 py-4">
                <div class="flex flex-col col-span-2 ">
                    <Field :label-visible="false" v-model="file.name" placeholder="Name"
                           :errors="getErrors('file_id')"
                    >
                        <SingleFileUpload
                            v-model:file="file.file"
                            accept=".xlx,.xls,.xlsx">
                            <template v-slot:default="{props, methods}">
                                <div class="grid grid-cols-2 gap-3">
                                    <div class="flex items-center underline text-sm bg-next-gray-md-dark px-3">
                                        <a class="underline text-next-atp break-words cursor-pointer"
                                           v-show="file?.file?.id" @click="downloadFile(file?.file?.id)">
                                            <span><i class="icon icon-graffetta"></i> {{ file?.file?.name }}</span>
                                        </a>
                                        <span v-show="!file?.file?.id">Vuoto</span>
                                    </div>
                                    <NextButton variant="outline-secondary" @click="methods.open"
                                                class="w-full h-10 px-4 col-start-2">
                                        <i class="icon icon-graffetta"></i> {{ file?.file ? 'Cambia' : 'Allega' }}
                                    </NextButton>
                                </div>
                            </template>
                        </SingleFileUpload>
                    </Field>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <Alert v-show="message.length > 0" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']">{{ message }}</Alert>
            <div class="flex justify-end pt-3 gap-3">
                <NextButton variant="primary"
                            :disabled="loading"
                            @click="carica"
                            class="py-2 px-4 flex items-center justify-center">
                    <Spinner v-show="loading" class="w-4 h-4 mr-4"></Spinner>
                    Importa
                </NextButton>
                <NextButton variant="outline-secondary"
                            @click="$emit('update:visible', false)"
                            class="col-start-3 py-2 px-4">
                    Chiudi
                </NextButton>
            </div>
        </template>
    </Modal>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {mapGetters} from 'vuex';
import NextButton from "@/components/NextButton.vue";
import Modal from "@/components/Modal.vue";
import Field from "@/components/Field.vue";
import SingleFileUpload from "@/components/SingleFileUpload.vue";
import Spinner from "@/components/Spinner.vue";
import sottoProgettiManager from "../api/SottoProgetti";
import Alert from "@/components/Alert.vue";
import me from "../api/Me";

@Options({
    name: 'ModalCaricaExcel',
    components: {Alert, Spinner, SingleFileUpload, Field, Modal, NextButton},
    props: {
        visible: Boolean,
        sottoprogetto_id: [Number, String]
    },
    inject: ['downloadFile'],
    computed: {},
})
export default class ModalCaricaExcel extends Vue {
    file: any = {};
    errors: any = {};
    loading: boolean = false;
    sottoprogetto_id!: string | number;
    message: string = '';
    esito: boolean = true;

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    carica() {
        this.loading = true;
        this.message = ''
        sottoProgettiManager.importExcel(this.sottoprogetto_id, {file_id: this.file?.file?.id}).then((response) => {
            this.esito = true;
            this.message = response.data.message
            this.file = {}
            this.$emit('success')
        }).catch((res) => {
            this.esito = false;
            this.message = res.response.data.message
            if (res.response.status == 422) {
                this.errors = res.response.data.errors;
            }
        }).finally(() => {
            this.loading = false;
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
